import type { ColumnDef } from '@tanstack/react-table';
import type { InvoiceLagRow } from '../../../services/accountingReports.service';
import { formatCurrency } from '../../../utils/money';

type Col = ColumnDef<InvoiceLagRow>;
const money = (accessorKey: string, header: string): Col => ({
  accessorKey, header, size: 140,
  cell: ({ getValue }) => formatCurrency(getValue()), meta: { aggType: 'sum' },
});
const day = (accessorKey: string, header: string): Col => ({
  accessorKey, header, size: 150, meta: { isDate: true, showTime: false },
});
/** senttoaccountingdate carries a real clock time since migration 487; show it when
 *  there is one (see hasNoClockTime for why an exact midnight stays date-only). */
const dayTime = (accessorKey: string, header: string): Col => ({
  accessorKey, header, size: 170, meta: { isDate: true, hideMidnightTime: true },
});
const txt = (accessorKey: string, header: string, size = 160): Col => ({ accessorKey, header, size });
const groupLabels: Record<string, string> = {
  division: 'Division', billto: 'Bill to', customer: 'Customer', invoicedby: 'Invoiced By',
};

/** V1 rpt_mgmt.pl:8298–8350; the server response determines the column set. */
export function invoiceLagColumns(mode: 'detail' | 'grouped', groupBy: string | null): Col[] {
  if (mode === 'grouped') return [
    txt('group', groupLabels[groupBy || ''] || 'Group', 200),
    txt('avginvoicelag', 'Average Invoice Lag (Days)', 200),
    txt('numinvtickets', 'Total # of Invoice Trouble Tickets', 240),
    txt('ttresolutiontime', 'Average Ticket Resolution Time', 240),
    money('invoicetotal', 'Total Invoice Amount'), money('creditamt', 'Total Credit Amount'),
    txt('numinvoices', 'Total Invoices'),
  ];
  return [
    txt('pronumber', 'Pro', 110), txt('masterpronum', 'Master Pro', 110),
    txt('invoicenumber', 'Invoice#'), txt('accessorialnum', 'Acc#', 80),
    txt('division', 'Division'), txt('movetype', 'Move Type'), txt('billto', 'Bill to', 220),
    txt('mas90code', 'Sage Tag'), txt('customer', 'Customer', 220),
    txt('container', 'Equipment#'), txt('bol', 'BOL/BKG#'), txt('csr', 'CSR'),
    txt('whsecsr', 'WCSR'), txt('invoicedby', 'Invoiced By'),
    day('createdate', 'Create Date'), day('deliverydate', 'Delivery Date'),
    day('terminatedate', 'Terminate Date'), day('procompletedate', 'Pro Complete Date'),
    day('mastercompdate', 'Master Complete Date'), txt('protomasterdays', 'Pro > Master Days'),
    dayTime('senttoaccdate', 'Sent to Acct Date'), txt('mastosentaccdays', 'Master > Sent to Acct Days', 210),
    day('invoicedate', 'Invoiced Date'), txt('senttoaccinvdays', 'Sent to Acct > Invoice Days', 210),
    txt('masterinvoicedays', 'Master > Invoice Days', 200),
    txt('numinvtickets', '# of Invoice Trouble Tickets', 220),
    txt('ttresolutiontime', 'Average Ticket Resolution Time', 240),
    money('invoicetotal', 'Invoice Amount'), money('creditamt', 'Credit Amount'),
  ];
}
